import { useSelector } from 'react-redux';

export const withOnline = (Component) => function WithOnlineWrapper(props) {
  const online = useSelector(({online}) => online);

  return <Component {...props} online={online} />;
}
